import React from 'react';

import { Table, Button, Modal, ModalHeader, ModalBody, Form, Card, Col } from 'reactstrap';


import useAuth from "Auth/useAuth"
import { ComponenteInputBuscar_, InputUsuarioStandar, Select1 } from "components/input/elementos";  // componente input que incluye algunas de las funcionalidades como, setInput, validaciones cambio de tipos
import { useState, useEffect } from "react";
import { URL, INPUT } from 'Auth/config';
import axios from 'axios';
import { Toaster, toast } from 'react-hot-toast'


import { API_ENDPOINTS } from './api';
import { start } from 'service';
import { eliminarDB } from 'service';
import { CabeceraFormulariosTratamientoLista } from 'views/diagnostico/input/elementos';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlayCircle, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import ReactPlayer from 'react-player';


export default function IEC_VIDEOS() {

  const auth = useAuth()

  const [listaIEC, setListaIEC] = useState([])  // idTipo de gasto desde la bd

  const [titulo, setTitulo] = useState({ campo: null, valido: null })
  const [descripcion, setDescripcion] = useState({ campo: null, valido: null })


  const [estadoEnvio, setEstadoEnvio] = useState(0);
  const [modalInsertar, setModalInsertar] = useState(false);
  const [inputBuscar, setInputBuscar] = useState({ campo: null, valido: null })  // BUSCADOR DE LA INFORMACION ASIGNACION Y GASTOS
  const [proteccion, setProteccion] = useState({ campo: null, valido: null })  // BUSCADOR DE LA INFORMACION ASIGNACION Y GASTOS


  const [direccion, setDireccion] = useState({ campo: null, valido: null })

  const [video, setVideo] = useState(null);
  const [lista, setLista] = useState([])
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (inputBuscar.valido === null) listar()
    if (inputBuscar.valido === 'false') listar()

    document.title = 'VIDEOS IEC'
  }, [])

  const token = localStorage.getItem("token")
  axios.interceptors.request.use(
    config => {
      config.headers.authorization = `Bearer ${token}`
      return config
    },
    error => {
      auth.logout()
      return Promise.reject(error)
    }
  )




  const opts = {
    height: window.innerWidth <= 768 ? '200' : '250',
    width: '100%',
    playerVars: {
      autoplay: 1,
    },
  };


  const listar = async () => {
    const data = await start(API_ENDPOINTS.IEC_VIDEOS.LISTAR)
    setListaIEC(data)
    if (data.length === 0) toast.error('No hay registros')
  }



  const insert = async () => {
    try {
      if (titulo.valido !== 'true' || descripcion.valido !== 'true' || direccion.valido !== 'true') {
        toast.error('Complete los campos');
        return;
      }

      if (titulo.campo.length > 55 || descripcion.campo.length > 80) {
        toast.error('El titulo o la descripcion exceden la cantidad de caracteres que indica');
        return;
      }
      if (estadoEnvio !== 0) {
        return;
      }

      setEstadoEnvio(1);

      const datos = {
        titulo: titulo.campo,
        descripcion: descripcion.campo,
        direccion: direccion.campo,
        proteccion: proteccion.campo,
      };

      await axios.post(API_ENDPOINTS.IEC_VIDEOS.GUARDAR, datos);
      listar()
      setModalInsertar(false)
      setTitulo({ campo: null, valido: null })
      setDescripcion({ campo: null, valido: null })
      setDireccion({ campo: null, valido: null })
      setEstadoEnvio(0)
    } catch (error) {
      setEstadoEnvio(0);
      toast.error('Error al guardar registro');
      console.error(error);
    }
  }




  const eliminarFolleto = async (id) => {
    let proteccion = prompt("Escribir el codigo de proteccion del archivo", "CODIGO DE ARCCHIVO");
    if (proteccion) {
      await eliminarDB(API_ENDPOINTS.IEC_VIDEOS.ELIMINAR, { id, proteccion })
      listar()
    }

  }

  const buscar = async (id) => {
    const data = await start(API_ENDPOINTS.IEC_VIDEOS.BUSCAR, { id })
    setListaIEC(data)
  }


  return (
    <>
      <div className="contentSimple"  >
        <div className="main-container">

          <CabeceraFormulariosTratamientoLista text={"CONTENIDO MULTIMEDIA EN VIDEOS"} />

          <div style={{ display: 'flex', justifyContent: 'end', marginBottom: '5px' }}>
            <button className='btn-new-transparent' pb={2} onClick={() => setModalInsertar(true)} >
              {window.innerWidth < 768 ? 'Nuevo' : 'Registro nuevo'}
            </button >
          </div>
          <Card>
            <div className="mt-2">
              <ComponenteInputBuscar_
                estado={inputBuscar}
                cambiarEstado={setInputBuscar}
                name="sub_categoria"
                // etiqueta='Buscar'
                ExpresionRegular={INPUT.TEXT} //expresion regular
                evento={buscar}
              />
            </div>

            <Table className="tablesorter" responsive>
              <thead className="text-primary">
                <tr>
                  <th ></th>
                  <th >TITULO</th>
                  <th>DESCRIPCION</th>
                  <th >AUTOR</th>
                  <th >VISTAS</th>
                  <th className="text-center">FECHA PUBLICACION</th>
                  <th className="text-center"></th>
                </tr>
              </thead>
              <tbody>
                {listaIEC.map(e => (
                  <tr key={e.id} style={{ cursor: 'pointer' }}
                  >
                    <td>
                      <FontAwesomeIcon icon={faPlayCircle}
                        style={{
                          color: 'blue',
                          height: '20px',
                          width: '20px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          setVideo({
                            id: e.id,
                            url: e.direccion,
                            titulo: e.titulo,
                            descripcion: e.descripcion,
                            view: e.views,
                            autor: e.autor
                          });
                          setOpen(true)
                        }}
                      />
                    </td>
                    <td>
                      <div className="tbl-name tbl-bold">{e.titulo}</div>
                    </td>
                    <td>
                      <div className="tbl-des ">{e.descripcion}</div>
                    </td>
                    <td>
                      <div className="tbl-name tbl-bold">{e.autor}</div>
                    </td>

                    <td>
                      <div className="tbl-des">{e.views}</div>
                    </td>
                    <td>
                      <div className="tbl-des tbl-bold">{e.fecha}</div>
                    </td>
                    <td>
                      <FontAwesomeIcon icon={faTrashAlt}
                        style={{
                          color: 'red',
                          height: '20px',
                          width: '20px',
                          cursor: 'pointer'
                        }}
                        onClick={() => {
                          eliminarFolleto(e.id)
                        }}
                      />
                    </td>
                  </tr>
                ))}

              </tbody>
              {listaIEC.length < 1 && 'lista vacia'}
            </Table>
          </Card>

          <Modal isOpen={modalInsertar}>

            <ModalHeader toggle={() => setModalInsertar(!modalInsertar)}>
              GUARDAR VIDEO
            </ModalHeader>
            <ModalBody>
              <Form>


                <InputUsuarioStandar
                  estado={titulo}
                  cambiarEstado={setTitulo}
                  name="titulo"
                  placeholder="TITULO"
                  ExpresionRegular={INPUT.TEXT}  //expresion regular
                  etiqueta='Titulo [max:55 caracteres]'
                  msg='Este acepta letras y caracteres'
                />

                <InputUsuarioStandar
                  estado={descripcion}
                  cambiarEstado={setDescripcion}
                  name="descripcion"
                  placeholder=" DESCRIPCION"
                  ExpresionRegular={INPUT.TEXT}  //expresion regular
                  etiqueta='Descripcion [max:80 caracteres]'
                  msg='Este acepta letra numero letras y caracteres'
                />

                <InputUsuarioStandar
                  estado={direccion}
                  cambiarEstado={setDireccion}
                  name="direccion"
                  placeholder=" DIRECCION URL"
                  ExpresionRegular={INPUT.TEXT}  //expresion regular
                  etiqueta='Direccion URL'
                  mayusculas={false}
                  msg='Este acepta letras numero letras y caracteres'
                />
                <InputUsuarioStandar
                  estado={proteccion}
                  cambiarEstado={setProteccion}
                  name="proteccion"
                  placeholder="PROTECCION"
                  ExpresionRegular={INPUT.TEXT}  //expresion regular
                  etiqueta='Codigo de proteccion de archivo'
                  msg='Este acepta letras y caracteres'
                />


              </Form>
            </ModalBody>
            <div className="boton-modal">
              <Button color="success" onClick={() => insert()}>
                Guardar
              </Button>
            </div>
          </Modal>

          <Modal isOpen={open} toggle={() => setOpen(!open)} className="modal-lg">
            <style>
              {`
              .modal-header{
                background:#212529;
              
                padding: 10px;
                border-radius:0;
              }
              .modal-content .modal-header .modal-title {
                color: white !important;
                margin-bottom: 0px;
              }
              .modal-header .close {
                color: white !important;
                display:none;
              }
                .white-content .modal-content {
                  background: transparent !important;
                }

                @media (min-width: 576px) {
                  .modal-dialog {
                    margin: 5px auto;
                  }
}
             
          `}
            </style>

            <ModalBody style={{ background: '#212529', padding: '0', display: 'flex', justifyContent: 'center' }}>
              {/* <img src={imagen?.url} alt={`Image ${imagen?.id}`} style={{ width: "auto", height: window.innerWidth < 600 ? 'auto' : window.innerHeight + 50 }} /> */}


              <ReactPlayer
                url={video?.url}
                controls={true}
                width="100%"
                height={window.innerWidth < 600 ? 'auto' : window.innerHeight + 50}
                opts={opts}

                onPlay={() => {
                  axios.post(URL + '/public/contar-visita', { id: video[0]?.id })
                  for (let item of lista) {
                    if (item.id === video[0]?.id) {
                      item.views++
                    }
                  }
                }}
              />


            </ModalBody>
            {/* <div style={{
              margin: '10px',
              padding: '10px',
              background: '#344675',
              position: "relative",
              bottom: window.innerWidth < 600 ? '100px' : '150px',
              zIndex: '1000',
              width: "300px",
              // height: 'auto'
            }}>
              {video ? <>
                <p style={{
                  color: 'white',
                  marginBottom: '0',
                  fontWeight: '600'
                }}>{video?.titulo}</p>
                <p style={{
                  color: 'white',
                  fontSize: '10px',
                  marginBottom: '0',
                }}>{video?.descripcion}</p>
                <p style={{
                  color: 'white',
                  fontSize: '9px',
                  marginBottom: '0',
                  fontWeight: '600',
                }}>{video?.autor}</p>
                <p style={{
                  color: 'white',
                  fontSize: '9px',
                  marginBottom: '0',
                }}>{video?.view}</p>
              </> : null}
            </div> */}
            <div
              style={{
                padding: '0',
                display: 'flex',
                justifyContent: 'center',
                position: 'relative',
                bottom:'20px',
                background: "transparent !important",
              }}
            >
              <Button color="info" onClick={() =>
                setOpen(false)
              }>
                cerrar
              </Button>

            </div>

          </Modal>

        </div>
      </div>
    </>
  );


}